import Phaser from "phaser";
import { floatingText } from "@yjsgames/phaser-fx";
import { BigNumber } from "@yjsgames/bignumber";
import { PALETTE } from "../themes/palette.js";
import { FONT_FAMILY } from "../ui/uiTokens.js";
import { formatBig } from "../ui/formatNumber.js";
import { DEPTH } from "../objects/depthLayers.js";
import type { BattlefieldRuntimePools } from "./battlefieldRuntimePools.js";
import type { Brick } from "../objects/Brick.js";

export function emitCombatGoldGainFx(
  scene: Phaser.Scene,
  runtime: BattlefieldRuntimePools,
  brick: Brick,
  amount: BigNumber,
): void {
  if (amount.isZero() || !runtime.allowTextFx()) return;
  const jitterX = Phaser.Math.Between(-3, 3);
  const startX = brick.x + jitterX;
  const startY = brick.y - brick.displayHeight / 2 - 24;
  const text = `+${formatBig(amount)}`;
  const labelX = startX + 8;
  const bgWidth = Math.max(42, text.length * 5.8 + 26);
  const bg = runtime.fxRectPool
    .acquire()
    .setPosition(startX + 3, startY)
    .setSize(bgWidth, 16)
    .setFillStyle(0x15120f, 0.02)
    .setStrokeStyle(1, 0xffd27a, 0.02)
    .setActive(true)
    .setVisible(true)
    .setDepth(DEPTH.combatGoldFxBg)
    .setAlpha(1)
    .setScale(1);
  const icon = runtime.fxImagePool
    .acquire()
    .setTexture("icon_gold")
    .setPosition(startX - bgWidth / 2 + 9, startY)
    .setActive(true)
    .setVisible(true)
    .setDepth(DEPTH.combatGoldFx)
    .setAlpha(0.06)
    .setScale(0.28)
    .setRotation(0)
    .setBlendMode(Phaser.BlendModes.NORMAL)
    .clearTint();
  const label = floatingText(scene, {
    x: labelX,
    y: startY,
    text,
    color: PALETTE.textBright,
    fontFamily: FONT_FAMILY,
    fontSize: "9px",
    depth: DEPTH.combatGoldFx,
    riseBy: 5,
    duration: 100,
    pool: runtime.fxTextPool,
  });
  label.setAlpha(0.06);
  runtime.maskFx([bg, icon, label]);
  scene.tweens.add({
    targets: [bg, icon],
    y: startY - 5,
    alpha: 0,
    duration: 100,
    ease: "Quad.easeOut",
    onComplete: () => {
      runtime.fxRectPool.release(bg);
      runtime.fxImagePool.release(icon);
    },
  });
}
